import React from "react";
import Loadable from "react-loadable";

import DefaultLayout from "./containers/DefaultLayout";

function Loading() {
  return <div>Loading...</div>;
}

const Page404 = Loadable({
  loader: () => import("./views/Pages/Page404/Page404"),
  loading: Loading,
});
const Dashboard = Loadable({
  loader: () => import("./views/Dashboard"),
  loading: Loading,
});

// Audits -------------------------------------------------

const Audits = Loadable({
  loader: () => import("./views/Audits/Audits"),
  loading: Loading,
});

const NewAudits = Loadable({
  loader: () => import("./views/Audits/NewAudit"),
  loading: Loading,
});

const AuditCategory = Loadable({
  loader: () => import("./views/Audits/AuditCategory"),
  loading: Loading,
});
//Coins ------------------------------------------------
const NewCoin = Loadable({
  loader: () => import("./views/Coin/NewCoin"),
  loading: Loading,
});
const Coin = Loadable({
  loader: () => import("./views/Coin/Coin"),
  loading: Loading,
});
// Posts -------------------------------------------------

const Posts = Loadable({
  loader: () => import("./views/Posts/Posts"),
  loading: Loading,
});

const NewPosts = Loadable({
  loader: () => import("./views/Posts/NewPosts"),
  loading: Loading,
});

const PostCategory = Loadable({
  loader: () => import("./views/Posts/PostCategory"),
  loading: Loading,
});

// Contacts -------------------------------------------------

const Contacts = Loadable({
  loader: () => import("./views/Contacts/Contacts"),
  loading: Loading,
});

// Users ----------------------------------------------

const Management = Loadable({
  loader: () => import("./views/Users/Management"),
  loading: Loading,
});

const Roles = Loadable({
  loader: () => import("./views/Users/Role"),
  loading: Loading,
});

const ChangePassword = Loadable({
  loader: () => import("./views/Users/ChangePassword"),
  loading: Loading,
});

// Settings ----------------------------------------------

const Global = Loadable({
  loader: () => import("./views/Settings/Global"),
  loading: Loading,
});

const Team = Loadable({
  loader: () => import("./views/Settings/Team"),
  loading: Loading,
});

const Faqs = Loadable({
  loader: () => import("./views/Settings/Faqs"),
  loading: Loading,
});

const Services = Loadable({
  loader: () => import("./views/Settings/Services"),
  loading: Loading,
});

const Logs = Loadable({
  loader: () => import("./views/Settings/Logs"),
  loading: Loading,
});

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: DefaultLayout,
    exact: true,
  },
  { path: "/dashboard", name: "Dashboard", component: Dashboard, exact: true },
  { path: "/audits", name: "Audits", component: Audits, exact: true },
  {
    path: "/audits/audit-new",
    name: "New Audit",
    component: NewAudits,
    exact: true,
  },
  {
    path: "/coin/coin-new",
    name: "New Coin",
    component: NewCoin,
    exact: true,
  },
  {
    path: "/coin",
    name: "All Coins",
    component: Coin,
  },
  {
    path: "/audits/categories",
    name: "Categories",
    component: AuditCategory,
    exact: true,
  },
  { path: "/posts", name: "Posts", component: Posts, exact: true },
  { path: "/posts/post-new", name: "New Post", component: NewPosts },
  { path: "/posts/categories", name: "Categories", component: PostCategory },
  { path: "/contacts", name: "Contacts", component: Contacts },
  { path: "/users/management", name: "Management", component: Management },
  { path: "/users/roles", name: "Roles", component: Roles },
  {
    path: "/users/change-password",
    name: "Change Password",
    component: ChangePassword,
  },
  { path: "/settings/team", name: "Team", component: Team },
  { path: "/settings/services", name: "Services", component: Services },
  { path: "/settings/faqs", name: "Faqs", component: Faqs },
  { path: "/settings/logs", name: "Logs", component: Logs },
  { path: "/settings/global", name: "Settings", component: Global },
  { path: "/*", name: "", component: Page404 },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js